import type { SlateElementProps } from 'platejs/static';
import { SlateElement } from 'platejs/static';

export function BlockquoteElementStatic(props: SlateElementProps) {
  return (
    <SlateElement
      as="blockquote"
      className="border-l-2 pl-4 plate-viewer-blockquote"
      {...props}
    />
  );
}
